module.exports = __webpack_public_path__ + "img/roadmap-impostor-1.91d9823f.png";